import { Outlet } from 'react-router-dom';
// import Sidebar from './Sidebar';
import Header from './Header';

export default function Layout() {
  return (
    <div className="min-h-screen bg-rose-50">
      <div className="flex-1 flex flex-col">
          
          <main className="flex-1">
            <Outlet />
          </main>
      </div>
    </div>  
  );
}